.a3{display:inline-flex;}